import { Navigate, Outlet, useLocation } from "react-router-dom";
import MasterClerkDashboard from "./MasterClerkDashboard";
import { isClerkDashboardRole } from "../utils/dashboardRole";

const hasUserToken = () => {
  const localToken = localStorage.getItem("authToken");
  const sessionToken = sessionStorage.getItem("authToken");
  return Boolean(localToken || sessionToken);
};

const hasAdminToken = () => Boolean(localStorage.getItem("adminToken"));

const ProtectedRoute = ({ requireAdmin = false }) => {
  const location = useLocation();

  if (requireAdmin) {
    if (!hasAdminToken()) {
      return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return <Outlet />;
  }

  if (!hasUserToken() && !hasAdminToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Appointment identity wins over legacy/direct URLs. This prevents a Clerk
  // from ever falling through to a BaseDashboard route left in old bookmarks,
  // browser history, or a stale link.
  if (
    location.pathname.startsWith("/dashboard/") &&
    isClerkDashboardRole(localStorage.getItem("role"))
  ) {
    return <MasterClerkDashboard />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
